import React, { memo } from "react";
import { Controller } from "react-hook-form";
import RequiredTitle from "./RequiredTitle";

const SelectField = ({ input, control, error }) => {
  const { name, type, label, validation, options = [], alignment = {}, defaultValues, ...rest } = input;
  const { sm = 12, md = 12, lg = 12 } = alignment;

  return (
    <div
      key={name}
      className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}
    >
      <RequiredTitle
        label={label}
        validation={validation}
      />
      <Controller
        name={name}
        control={control}
        rules={validation}
        defaultValue={defaultValues}
        render={({ field }) => (
          <div>
            {options?.map((row, index) => (
              <label className="radio-inline me-3" key={index}>
                <input type="radio" name={row} /> {row}
              </label>
            ))}
            {error && <div className="invalid-feedback">{error}</div>}
          </div>
        )}
      />
    </div>
  );
};

export default memo(SelectField);
